import React from "react";

export const SkeletonView: React.FC = () => {
  return (
    <div className="w-full animate-pulse space-y-10">
      {/* Header Skeleton */}
      <div className="flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
        <div className="space-y-2">
          <div className="h-10 w-64 rounded-lg bg-neutral-200" />
          <div className="h-5 w-40 rounded-md bg-neutral-100" />
        </div>
        <div className="flex gap-3">
          <div className="h-10 w-32 rounded-xl bg-neutral-100" />
          <div className="h-10 w-40 rounded-xl bg-neutral-100" />
        </div>
      </div>

      {/* Tabs and Version Selector Skeleton */}
      <div className="flex items-center justify-between border-b border-neutral-100 pb-5">
        <div className="h-12 w-64 rounded-xl bg-neutral-100" />
        <div className="h-12 w-80 rounded-xl bg-neutral-100" />
      </div>

      {/* Summary and Background Grid Skeleton */}
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
        <div className="h-48 rounded-2xl bg-neutral-50 ring-1 ring-neutral-100" />
        <div className="h-48 rounded-2xl bg-neutral-50 ring-1 ring-neutral-100" />
      </div>

      {/* Visits Section Skeleton */}
      <div className="space-y-6">
        <div className="h-16 rounded-2xl bg-neutral-50 ring-1 ring-neutral-100" />
        <div className="space-y-4">
          {[1, 2, 3].map((i) => (
            <div key={i} className="h-32 rounded-2xl bg-neutral-50 ring-1 ring-neutral-100" />
          ))}
        </div>
      </div>
    </div>
  );
};
